import { render, staticRenderFns } from "./LinkToolbarButton.vue?vue&type=template&id=6711ff96&"
import script from "./LinkToolbarButton.vue?vue&type=script&lang=js&"
export * from "./LinkToolbarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports